"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfessionalSummaryDto = instanceOfProfessionalSummaryDto;
exports.ProfessionalSummaryDtoFromJSON = ProfessionalSummaryDtoFromJSON;
exports.ProfessionalSummaryDtoFromJSONTyped = ProfessionalSummaryDtoFromJSONTyped;
exports.ProfessionalSummaryDtoToJSON = ProfessionalSummaryDtoToJSON;
exports.ProfessionalSummaryDtoToJSONTyped = ProfessionalSummaryDtoToJSONTyped;
/**
 * Check if a given object implements the ProfessionalSummaryDto interface.
 */
function instanceOfProfessionalSummaryDto(value) {
    if (!('professionalSummary' in value) || value['professionalSummary'] === undefined)
        return false;
    return true;
}
function ProfessionalSummaryDtoFromJSON(json) {
    return ProfessionalSummaryDtoFromJSONTyped(json, false);
}
function ProfessionalSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'professionalSummary': json['professionalSummary'],
    };
}
function ProfessionalSummaryDtoToJSON(json) {
    return ProfessionalSummaryDtoToJSONTyped(json, false);
}
function ProfessionalSummaryDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'professionalSummary': value['professionalSummary'],
    };
}
//# sourceMappingURL=ProfessionalSummaryDto.js.map